import ApiConnector from '../connector/ApiConnector';
import OrderItem from '../model/OrderItem';
import OrderMashaller from '../model/OrderMarshaller';

export default class OrderRepository {
    private apiConnector:ApiConnector
    
    constructor() {
        this.apiConnector = new ApiConnector();
    }

    public getCart() {
       return this.apiConnector.get('/api/getCart').then(cart => {
            
            return new OrderMashaller(cart).toModel()
       })
    }

    public saveItem(orderItem:OrderItem) {

        let orderRequest = {
            
        }

        this.apiConnector.post('/api/orderPizza',orderRequest)
    }
}